import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  FormControl,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  Card,
  TableRow,
  Paper,
  IconButton,
} from "@mui/material"
import Grid from "@mui/material/Grid2"
import { useState } from "react"

const BillingDetails = ({
  subtotal,
  total,
  discount,
  discountPercent,
  totalDiscountAmount,
  handleDiscountChange,
  handleDiscountPercentChange,
}) => {
  return (
    <>
      <Card
        sx={{
          boxShadow: "none",
          borderRadius: "7px",
        }}
        className="rmui-card border"
      >
        <Typography
          variant="h3"
          sx={{
            fontSize: { xs: "16px", md: "18px" },
            fontWeight: 700,
            px: { xs: 2, md: 3 },
            py: { xs: 1.5, md: 2 },
          }}
          className="text-black bg-f6f7f9"
        >
          Billing Details
        </Typography>

        <Box sx={{ px: { xs: 2, md: 3 }, py: { xs: 1.5, md: 2 } }}>
          <Table sx={{ width: "100%" }}>
            <TableBody>
              <TableRow>
                <TableCell
                  sx={{
                    border: "none",
                    py: 1,
                    fontWeight: "normal",
                    color: "black",
                  }}
                >
                  Subtotal:
                </TableCell>
                <TableCell sx={{ border: "none", py: 1 }}>
                  Rs. {subtotal}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell
                  sx={{
                    border: "none",
                    py: 1,
                    fontWeight: "normal",
                    color: "black",
                  }}
                >
                  Discount %:
                </TableCell>
                <TableCell sx={{ border: "none", py: 1 }}>
                  <TextField
                    value={discountPercent || 0}
                    variant="standard"
                    type="number"
                    onFocus={(event) => {
                      event.target.select()
                    }}
                    onChange={handleDiscountPercentChange}
                    sx={{ width: { xs: "100%", sm: "60px" } }}
                    inputProps={{ min: 0 }}
                  />
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell
                  sx={{
                    border: "none",
                    py: 1,
                    fontWeight: "normal",
                    color: "black",
                  }}
                >
                  Discount amount:
                </TableCell>
                <TableCell sx={{ border: "none", py: 1 }}>
                  <TextField
                    value={discount || 0}
                    variant="standard"
                    type="number"
                    onFocus={(event) => {
                      event.target.select()
                    }}
                    onChange={handleDiscountChange}
                    sx={{ width: { xs: "100%", sm: "60px" } }}
                    inputProps={{ min: 0 }}
                  />
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell
                  sx={{
                    border: "none",
                    py: 1,
                    fontWeight: "normal",
                    color: "black",
                  }}
                >
                  Total Discount amount:
                </TableCell>
                <TableCell
                  sx={{
                    border: "none",
                    py: 1,
                    fontWeight: 500,
                    color: "black",
                  }}
                >
                  Rs. {totalDiscountAmount || 0}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell
                  sx={{
                    border: "none",
                    py: 1,
                    fontWeight: "normal",
                    color: "black",
                  }}
                >
                  Grand Total:
                </TableCell>
                <TableCell
                  sx={{
                    border: "none",
                    py: 1,
                    fontWeight: 500,
                    color: "black",
                  }}
                >
                  Rs. {total}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Box>
      </Card>
    </>
  )
}

export default BillingDetails
